export const NESTED_PRODUCT_CODES = {
    NP002: 'NESTED_PRODUCT_ALREADY_EXISTS',
    NP003: 'NESTED_PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE',
};
